<template>
  <q-layout view="hHh lpR fFf" class="auth-layout">
    <q-page-container>
      <div class="auth-center">

        <!-- Лого -->
        <q-img
          src="@/assets/logo.png"
          alt="Мегасофт Плус"
          style="width: 110px; height: 110px"
          spinner-color="mint"
          class="q-mb-lg logo-shadow"
        />

        <!-- Страница за најава / регистрација -->
        <router-view />

      </div>
    </q-page-container>

  </q-layout>
</template>

<script>
export default {
  name: "AuthLayout",
};
</script>

<style scoped>

/* === Позадински стил (mint градиент) === */
.auth-layout {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: linear-gradient(180deg, #f0f4f4 0%, #e8f0ef 100%);
}

/* === Центрираната кутија за Login — подигната нагоре === */
.auth-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
  text-align: center;

  margin-top: -130px;   
}

/* === Лого со сенка === */
.logo-shadow {
  filter: drop-shadow(0 4px 8px rgba(14, 107, 95, 0.25));
}

/* === Ресет на рамки === */
* {
  border: none !important;
}

</style>
